export default "__VITE_ASSET__0qnkrcW8__"